import Section1 from '../components/menu/Section1'
import Section2 from '../components/menu/Section2'

function Menu() {

  
  return (
    <div className='bg-bgcolor font-font1'>
        <Section1/>
        <Section2/>
    </div>
  )
}

export default Menu